import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const consent = localStorage.getItem('besume_cookie_consent');
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('besume_cookie_consent', 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('besume_cookie_consent', 'declined');
    setVisible(false);
  };

  // Hide cookie banner during interview (input bar occupies bottom)
  const isInInterview = window.location.pathname === '/interview';

  if (!visible || isInInterview) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-[#e0e0e0] z-50"
      data-testid="cookie-banner"
    >
      <div className="max-w-5xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-[#555] text-center sm:text-left">
          Besume uses cookies for authentication and to improve your experience.
        </p>
        <div className="flex items-center gap-3 flex-shrink-0">
          <Link 
            to="/privacy" 
            className="text-sm text-[#777] hover:text-[#0a0a0a] underline underline-offset-2"
          >
            Learn More
          </Link>
          <Button
            onClick={handleDecline}
            variant="outline"
            className="rounded-none px-6"
            data-testid="cookie-decline-btn"
          >
            Decline
          </Button>
          <Button
            onClick={handleAccept}
            className="rounded-none bg-[#0a0a0a] text-white hover:bg-[#333] px-6"
            data-testid="cookie-accept-btn"
          >
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
